import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

import { CoinEventRules } from '@/features/coin-event/components/coin-event-rules';
import { useReward } from '@/contexts/reward-context';
import { SabaCoinEventRulesTypeEnum } from '@/types';

export function RulesAndResetTimeContainer({ children }: { children: React.ReactNode }) {
	const { onKafkaSet } = useReward();
	const [isShowRules, setIsShowRules] = useState(false);
	const [ruleType, setRuleType] = useState(SabaCoinEventRulesTypeEnum.SabaCoinEvent)

	const openRules = () => {
		onKafkaSet({
			type: 3,
			action: 26
		});

		setIsShowRules(true);
	};

	const closeRules = () => {
		setIsShowRules(false);
	};

	useEffect(() => {
		const openRewardLevelRules = ((event: CustomEvent) => {
			const isOpenRewardLevelRule = event.detail.openRewardLevelRule;

			if (isOpenRewardLevelRule) {
				setRuleType(SabaCoinEventRulesTypeEnum.RewardLevel);
				setIsShowRules(true);
			} else {
				setRuleType(SabaCoinEventRulesTypeEnum.SabaCoinEvent);
			}
		}) as EventListener;

		document.addEventListener('show-saba-coin-reward-level-rule', openRewardLevelRules);

		return () => {
			document.removeEventListener('show-saba-coin-reward-level-rule', openRewardLevelRules);
		}
	})

	return (
		<>
			<div
				className="shop-coin-head__timer"
				onClick={openRules}
			>
				{children}
			</div>

			{isShowRules ? createPortal(
				<CoinEventRules
					onClose={closeRules}
					ruleType={ruleType}
				/>,
				document.getElementById('shop-wrapper')!
			) : null}
		</>
	);
}